import React, { useState } from 'react';
import { deleteUserViaEdge, getUserDeleteInfo, UserDeleteInfo } from "@/utils/deleteUserUtils";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { DeleteUserPopup } from "../user/DeleteUserPopup";
import { useUserCrud } from '@/hooks/admin/users/useUserCrud';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '../ui/use-toast';
import { useNavigate } from 'react-router-dom';

export interface DeleteAccountAreaProps {
    userId: string;
}

export const DeleteAccountArea: React.FC<DeleteAccountAreaProps> = ({ userId }) => {
    // response will be either the delete-info object or null
    const [response, setResponse] = useState<UserDeleteInfo | null>(null);
    const navigate = useNavigate();

    const askToDelete = async (): Promise<void> => {
        try {
            const info: UserDeleteInfo = await getUserDeleteInfo(userId);
            setResponse(info);
        } catch (error) {
            console.error("Failed to fetch delete info:", error);
        }
    };

    const onClose = (): void => {
        setResponse(null);
    };

    const onConfirm = async () => {
        // invoke actual delete action here, e.g. call deleteUser(userId)

        let res = await deleteUserViaEdge(userId);
        if (res) {

            setResponse(null);
            const { error } = await supabase.auth.signOut();
            if (error) throw error;

            toast({
                title: "Logged out successfully",
                description: "You have been logged out of your account.",
            });

            navigate('/');
        } else { }
        console.log("Confirmed deletion for user", userId);


    };

    return (
        <Card className="shadow overflow-hidden border-0">
            <CardHeader className="pb-2 px-6 pt-6 bg-gradient-to-r from-[#FFF4F4] to-white">
                <CardTitle className="text-xl font-semibold text-[#B94A48]">Delete Account</CardTitle>
            </CardHeader>

            <CardContent className="px-6 pb-6 space-y-4">
                <p className="text-sm text-[#7A3E3E]">
                    Deleting your account is irreversible. All your data will be permanently removed. Please proceed with caution.
                </p>

                {response !== null && (
                    <DeleteUserPopup
                        userId={userId}
                        userName={''}
                        isOpen={true}
                        userStatus={{
                            hasStripeSub: response.has_active_subscription,
                            hasReferrals: response.has_referrals,
                            isOnTrial: response.has_trials,
                        }}
                        onClose={onClose}
                        onConfirm={onConfirm}
                    />
                )}

                <Button
                    onClick={askToDelete}
                    variant="destructive"
                    className="inline-flex w-full items-center px-4 py-2 bg-red-600 text-white text-sm font-medium shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                    Delete User
                </Button>
            </CardContent>
        </Card>
    );
};

export default DeleteAccountArea;
